import { VERTICAIS_OPTIONS } from 'domain/feature/hotsite/Forms/NewPublicOrganRegister/constants'

export const OPPORTUNITY_VERTICAL_OTHER_ID = 'other'

export const OPPORTUNITY_VERTICAL_OPTIONS = [
  ...VERTICAIS_OPTIONS,
  { id: OPPORTUNITY_VERTICAL_OTHER_ID, labelKey: 'scouting.opportunity.vertical.other' },
]

export const createDefaultVerticalSelection = (): Record<string, boolean> =>
  Object.fromEntries(OPPORTUNITY_VERTICAL_OPTIONS.map(option => [option.id, false]))
